import React from 'react';
import { assertNever } from '../../../utils/helpers';

import { museum } from '../../../data';
import { RIntroContentRemoteMuseumTranscriptionDemo } from './r-intro-content-remote-museum-demo';
import { RIntroContentRemoteMuseumTranscriptionBrighton } from './r-intro-content-remote-museum-brighton';
import { RIntroContentRemoteMuseumTranscriptionMunch } from './r-intro-content-remote-museum-munch';
import { RIntroContentRemoteMuseumTranscriptionCop26 } from './r-intro-content-remote-museum-cop26';


const Transcript = (museum.slug === 'demo') ? RIntroContentRemoteMuseumTranscriptionDemo
                 : (museum.slug === 'brighton') ? RIntroContentRemoteMuseumTranscriptionBrighton
                 : (museum.slug === 'munch') ? RIntroContentRemoteMuseumTranscriptionMunch
                 : (museum.slug === 'mpu') ? RIntroContentRemoteMuseumTranscriptionDemo
                 : (museum.slug === 'cop-26') ? RIntroContentRemoteMuseumTranscriptionCop26
                 : assertNever(museum.slug);


const RIntroContentRemoteMuseumTranscription: React.FC = () => {
  return <Transcript />;
};

export {
  RIntroContentRemoteMuseumTranscription,
};
